const INPUT_FORMATS = {
    FORMAT_TYPE : {
        currency: "currency",
        number: "number"
    },
    FORMAT : {
        'currency' :
            {
                decimalScale: 2,
                format: null,
                mask: null,
                thousandSeparator: ',',
                decimalSeparator: '.',
                prefix : '$',
                suffix: ''
            },
        'number' :
            {
                decimalScale: null,
                format: null,
                mask: null,
                thousandSeparator: ',',
                decimalSeparator: '.',
                prefix : '',
                suffix: ''
            },
        'phone':
            {   format: '1-###-###-####',
                mask: '_',
                thousandSeparator: '',
                decimalSeparator: null,
                prefix : null,
                decimalScale: null,
                suffix: ''
            }
    }
}

export default INPUT_FORMATS
